import { DachCountryCode } from 'signup-ui-lego-core/constants/CountryCode';
import { getCountryCode } from '../store/app/selectors';
export const isDACHCountry = state => {
  const country = getCountryCode(state);
  return Object.values(DachCountryCode).includes(country);
};